const hoursInDay = 8

const resources = {
  folder: {
    title: 'Folder',
    hasChildren: true,
  },
  template: {
    title: 'Task Template',
    linkBased: true,
    baselineBased: true,
    hasChildren: true,
  },
  labour: {
    title: 'Labour',
    timeBased: true,
  },
  team: {
    title: 'Team',
    linkBased: true,
    timeBased: true,
    templatePriceBased: true,
    hasChildren: true,
  },
  materials: {
    title: 'Materials',
    rateBased: true,
  },
  hire: {
    title: 'Hire',
    timeBased: true,
    rateBased: true,
  },
  waste: {
    title: 'Waste',
    rateBased: true,
    volumeBased: true,
  },
  misc: {
    title: 'Misc',
    rateBased: true,
  },
}

const resourceOrder = [
  'template',
  'labour',
  'team',
  'materials',
  'hire',
  'waste',
  'misc',
]

const markupConfig = {
  team: {
    alias: 'labour',
  },
  template: {
    ignore: true,
  }
}

const markupOrder = resourceOrder.filter(type => {
  const config = markupConfig[type]
  if(!config) return true
  if(config.alias || config.ignore) return false
  return true
})

const timeUnits = [{
  type: 'time',
  title: 'Hour',
  unit: 'hour',
  hours: 1,
},{
  type: 'time',
  title: 'Day',
  unit: 'day',
  days: 1,
},{
  type: 'time',
  title: 'Week',
  unit: 'week',
  days: 5,
},{
  type: 'time',
  title: '6 day Week',
  unit: 'week6',
  days: 6,
},{
  type: 'time',
  title: '7 day Week',
  unit: 'week7',
  days: 7,
}]

const timeUnitKeys = timeUnits.map(u => u.unit)

const weightUnits = [{
  type: 'weight',
  title: 'Gram',
  unit: 'g',
  kilograms: 1 / 1000,
}, {
  type: 'weight',
  title: 'Kilogram',
  unit: 'kg',
  kilograms: 1,
}, {
  type: 'weight',
  title: 'Ton',
  unit: 'ton',
  kilograms: 1000,
}]

const distanceUnits = [{
  type: 'distance',
  title: 'Millimetre',
  unit: 'mm',
  metres: 1 / 1000,
}, {
  type: 'distance',
  title: 'Centimetre',
  unit: 'cm',
  metres: 1 / 100,
}, {
  type: 'distance',
  title: 'Metre',
  unit: 'm',
  metres: 1,
}]

const areaUnits = [{
  type: 'area',
  title: 'Centimetres Squared',
  unit: 'cm2',
  metresSquared: 1 / 10000,
  disablePluralTitle: true,
}, {
  type: 'area',
  title: 'Metres Squared',
  unit: 'm2',
  metresSquared: 1,
  disablePluralTitle: true,
}]

const volumeUnits = [{
  type: 'volume',
  title: 'Centimetres Cubed',
  unit: 'cm3',
  metresCubed: 1 / 1000000,
  disablePluralTitle: true,
}, {
  type: 'volume',
  title: 'Metres Cubed',
  unit: 'm3',
  metresCubed: 1,
  disablePluralTitle: true,
}]

const miscUnits = [{
  type: 'misc',
  title: 'Bag',
  unit: 'bag',
}, {
  type: 'misc',
  title: 'Item',
  unit: 'item',
}]

// time units at the end because time based resoures will filter down to just time units
const allUnits = [
  miscUnits,
  distanceUnits,
  weightUnits,
  areaUnits,
  volumeUnits,
  timeUnits,
].reduce((all, group) => all.concat(group), [])

const allUnitMap = allUnits.reduce((all, unit) => {
  all[unit.unit] = unit
  return all
}, {})

const units = {
  time: timeUnits,
  weight: weightUnits,
  distance: distanceUnits,
  area: areaUnits,
  volume: volumeUnits,
  misc: miscUnits,
  all: allUnits,
  map: allUnitMap,
}

module.exports = {
  hoursInDay,
  resources,
  resourceOrder,
  units,
  markupConfig,
  markupOrder,
  timeUnitKeys,
}